import React, { createContext, useContext, useState } from 'react';

const DownloadStripContext = createContext();

export const DownloadStripProvider = ({ children }) => {
  const [downloadStrip, setDownloadStrip] = useState(false);

  return (
    <DownloadStripContext.Provider value={{ downloadStrip, setDownloadStrip }}>
      {children}
    </DownloadStripContext.Provider>
  );
};

export const useDownloadStrip = () => useContext(DownloadStripContext);
